<isophi-info-popup
  *transloco="let t"
  [title]="t('pap/popup/title')"
  [continueLabel]="t('pap/popup/continue')"
  [(dontShowAgain)]="dontShowAgain"
  (closed)="close()"
>
  <img src="../../../../../assets/img/foto/isophi-skolicka-357.jpg" alt="" />
  <div class="text-wrapper">
    <div [innerHTML]="t('pap/popup/text1')"></div>
    <div [innerHTML]="t('pap/popup/text2')"></div>
    <div [innerHTML]="t('pap/popup/text3')"></div>
    <div [innerHTML]="t('pap/popup/text4')"></div>
    <div [innerHTML]="t('shared/popup/contact')"></div>
  </div>
</isophi-info-popup>
